// extracted by mini-css-extract-plugin
export default {"card":"Card_card__57-b7","info":"Card_info__sJJ6J"};